export const ERROR_TEXT_ID = 'redirect-type-error-text';
